export default __webpack_public_path__ + "static/media/property-image.23de9c7f.svg";